import axios from "axios";

// Turns any thrown API error into a sentence that is safe to show a user. The backend
// sometimes replies with a plain string and sometimes with an object carrying `message`;
// a network failure has no response at all.
export const getApiErrorMessage = (err: unknown, fallback: string = "Something went wrong. Please try again."): string => {
  if (axios.isAxiosError(err)) {
    if (err.code === "ERR_NETWORK" || !err.response) {
      return "Unable to reach the server. Please check your connection and try again.";
    }
    const data = err.response.data;
    if (typeof data === "string" && data.trim()) return data;
    if (data && typeof data === "object" && typeof (data as { message?: unknown }).message === "string") {
      return (data as { message: string }).message;
    }
  }
  return fallback;
};
